import CategoriesSlider from "./CategoriesSlider";

export default CategoriesSlider;
